import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getPath, PathUnit } from '@/app/consts/path.const';
import { HeaderService } from './header.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, TegelModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  private headerService = inject(HeaderService);
  
  selectedStorage$ = new BehaviorSubject<string>('');
  devStorageLabel = 'Development Storage';
  prodStorageLable = 'Production Storage';
  devStorageUrl = '/dev-storage';
  prodStorageUrl = '/prod-storage';
  activeHeaderItem = '';
  profilePic: string | null = null;
  default = 'assets/icons/default-profile.svg';
  profile = {
    name: 'User Name',
    jobTitle: 'Job Title',
    email:"userName@email.com"
  };
  systemSettingPath = getPath(PathUnit.SystemSettings);
  landingPage = getPath(PathUnit.LandingPage);
  mobileNavOpen = this.headerService.mobileNavOpen;
  ngOnInit(){
  }
  
  toggleMobileSideMenu() {
    this.headerService.toggleMobileSideMenu();
  }

  updateSelectedStorage(storage: string) {
    this.selectedStorage$.next(storage);
  }

  logout() {
    // Basic logout logic for the component UI if needed, 
    // but the main tool logic is handle in role-validator
    console.log('Logout clicked');
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }

  isAdmin(): boolean {
    // Implementation for admin check
    return true;
  }
} 